// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__OQwLa","colMin":"styles_colMin__m-Sef","colCheckbox":"styles_colCheckbox__2XQfY"};